module.exports = flarum.core.compat['utils/SubtreeRetainer'];